// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const Plus = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
            <polygon
                fill="currentColor"
                points="6.923 20.923 6.923 20 5.077 20 5.077 20.923 5.077 25.077 .923 25.077 0 25.077 0 26.923 .923 26.923 5.077 26.923 5.077 31.077 5.077 32 6.923 32 6.923 31.077 6.923 26.923 11.077 26.923 12 26.923 12 25.077 11.077 25.077 6.923 25.077"
                transform="translate(0 -20)"
            />
        </svg>
    );
};

export default React.memo(Plus);
